
import React, { useState } from "react";
import {
  addDoc,
  collection,
  doc,
  getDocs,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import { db } from "../firebase";
import { traders } from "./CopyTrading";

const COLLECTION_NAME = "tradingcoping";

const CRYPTO_PAIRS = [
  "BTC-USDT", "ETH-USDT", "SOL-USDT", "XRP-USDT",
  "ADA-USDT", "DOGE-USDT", "TRX-USDT", "OKB-USDT",
  "BNB-USDT", "LTC-USDT", "BCH-USDT", "DOT-USDT",
  "LINK-USDT", "AVAX-USDT", "TON-USDT", "SHIB-USDT",
  "PEPE-USDT",
];

const FOREX_PAIRS = [
  "AUDCAD", "AUDCHF", "AUDJPY", "AUDNZD",
  "AUDUSD", "EURAUD", "EURUSD", "EURGBP",
  "EURJPY", "EURNZD", "GBPUSD", "NZDUSD",
];

const initialForm = {
  name: "",
  type: "Forex",
  pair: "EURUSD",
  style: "BFctrade Swing",
  roi: "5",
  win: "60",
  followers: "100",
  copiers: "50",
  aum: "10000",
  risk: "Medium",
  ret: "5",
  avatar: "👤",
  verified: true,
};

export default function AdminAddCopyTrading() {
  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  function updateField(event) {
    const { name, value } = event.target;

    setForm((previous) => ({
      ...previous,
      [name]: value,
      ...(name === "type"
        ? {
            pair: value === "Crypto" ? CRYPTO_PAIRS[0] : FOREX_PAIRS[6],
          }
        : {}),
    }));
  }

  async function handleAddTrader(event) {
    event.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      if (!form.name.trim()) {
        throw new Error("Weka jina la trader.");
      }

      const trader = {
        name: form.name.trim(),
        type: form.type,
        pair: form.pair,
        style: form.style.trim(),
        roi: Number(form.roi),
        win: Number(form.win),
        followers: Number(form.followers),
        copiers: Number(form.copiers),
        aum: Number(form.aum),
        risk: form.risk,
        ret: Number(form.ret),
        avatar: form.avatar || "👤",
        curve: [35, 45, 55, 65, 60],
        verified: Boolean(form.verified),
        createdAt: serverTimestamp(),
      };

      await addDoc(collection(db, COLLECTION_NAME), trader);

      setMessage("Trader ameongezwa kwenye tradingcoping.");
      setForm(initialForm);
    } catch (error) {
      setMessage(error.message || "Imeshindikana kuongeza trader.");
    } finally {
      setLoading(false);
    }
  }

  async function handleImportAll() {
    setLoading(true);
    setMessage("");

    try {
      const snapshot = await getDocs(
        collection(db, COLLECTION_NAME)
      );

      const existingIds = new Set(
        snapshot.docs.map((item) => String(item.id))
      );

      let added = 0;
      let skipped = 0;

      for (let index = 0; index < traders.length; index++) {
        const trader = traders[index];
        const documentId = String(trader.id);

        if (existingIds.has(documentId)) {
          skipped++;
          continue;
        }

        const pairList =
          trader.type === "Crypto" ? CRYPTO_PAIRS : FOREX_PAIRS;

        const pair = trader.pair || pairList[index % pairList.length];

        await setDoc(doc(db, COLLECTION_NAME, documentId), {
          ...trader,
          pair,
          createdAt: serverTimestamp(),
        });

        added++;
      }

      setMessage(
        `Imekamilika: traders ${added} wameongezwa; ${skipped} tayari walikuwepo.`
      );
    } catch (error) {
      setMessage(
        error.message ||
          "Import imeshindikana. Hakikisha Firebase imeunganishwa."
      );
    } finally {
      setLoading(false);
    }
  }

  const pairs =
    form.type === "Crypto" ? CRYPTO_PAIRS : FOREX_PAIRS;

  return (
    <main style={styles.page}>
      <section style={styles.container}>
        <h1 style={styles.title}>Admin — Copy Trading</h1>
        <p style={styles.subtitle}>
          Ongeza traders na hifadhi taarifa kwenye Firestore.
        </p>

        <button
          type="button"
          onClick={handleImportAll}
          disabled={loading}
          style={styles.importButton}
        >
          {loading ? "Inachakata..." : `Import Traders ${traders.length}`}
        </button>

        <form onSubmit={handleAddTrader} style={styles.form}>
          <h2 style={styles.heading}>Add New Trader</h2>

          <label style={styles.label}>Trader Name</label>
          <input
            style={styles.input}
            name="name"
            value={form.name}
            onChange={updateField}
            placeholder="Jina la trader"
            required
          />

          <label style={styles.label}>Market</label>
          <select
            style={styles.input}
            name="type"
            value={form.type}
            onChange={updateField}
          >
            <option value="Forex">Forex</option>
            <option value="Crypto">Crypto</option>
          </select>

          <label style={styles.label}>Trading Pair</label>
          <select
            style={styles.input}
            name="pair"
            value={form.pair}
            onChange={updateField}
          >
            {pairs.map((pair) => (
              <option key={pair} value={pair}>
                {pair}
              </option>
            ))}
          </select>

          <label style={styles.label}>Trading Style</label>
          <input
            style={styles.input}
            name="style"
            value={form.style}
            onChange={updateField}
            required
          />

          <div style={styles.grid}>
            <Field label="ROI (%)" name="roi" value={form.roi} onChange={updateField} />
            <Field label="Win Rate (%)" name="win" value={form.win} onChange={updateField} />
            <Field label="Followers" name="followers" value={form.followers} onChange={updateField} />
            <Field label="Copiers" name="copiers" value={form.copiers} onChange={updateField} />
            <Field label="AUM" name="aum" value={form.aum} onChange={updateField} />
            <Field label="Return (%)" name="ret" value={form.ret} onChange={updateField} />
          </div>

          <label style={styles.label}>Risk</label>
          <select
            style={styles.input}
            name="risk"
            value={form.risk}
            onChange={updateField}
          >
            <option>Low</option>
            <option>Medium</option>
            <option>High</option>
          </select>

          <label style={styles.label}>Avatar / Emoji</label>
          <input
            style={styles.input}
            name="avatar"
            value={form.avatar}
            onChange={updateField}
          />

          <button
            type="submit"
            disabled={loading}
            style={styles.submitButton}
          >
            {loading ? "Inahifadhi..." : "Add Trader"}
          </button>

          {message && (
            <p role="status" style={styles.message}>
              {message}
            </p>
          )}
        </form>
      </section>
    </main>
  );
}

function Field({ label, name, value, onChange }) {
  return (
    <label style={styles.field}>
      <span>{label}</span>
      <input
        style={styles.input}
        name={name}
        type="number"
        min="0"
        step="any"
        value={value}
        onChange={onChange}
        required
      />
    </label>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background: "#080d16",
    color: "#f4f6fb",
    padding: "20px 12px",
    fontFamily: "Inter, system-ui, sans-serif",
  },
  container: {
    maxWidth: "650px",
    margin: "0 auto",
  },
  title: { fontSize: "23px", marginBottom: "6px" },
  subtitle: { color: "#929db0", fontSize: "13px" },
  form: {
    marginTop: "18px",
    padding: "18px",
    border: "1px solid #263349",
    borderRadius: "14px",
    background: "#101724",
  },
  heading: { fontSize: "17px", marginTop: 0 },
  label: {
    display: "block",
    marginTop: "13px",
    marginBottom: "6px",
    fontSize: "12px",
    color: "#b7c3d5",
  },
  input: {
    width: "100%",
    minWidth: 0,
    padding: "11px",
    border: "1px solid #303c50",
    borderRadius: "8px",
    background: "#0b1220",
    color: "#f4f6fb",
    fontSize: "13px",
    boxSizing: "border-box",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: "10px",
    marginTop: "12px",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    fontSize: "12px",
    color: "#b7c3d5",
    minWidth: 0,
  },
  importButton: {
    width: "100%",
    padding: "13px",
    background: "#1c2c46",
    color: "#b9d4ff",
    border: "1px solid #355780",
    borderRadius: "9px",
    fontWeight: 700,
    cursor: "pointer",
  },
  submitButton: {
    width: "100%",
    marginTop: "18px",
    padding: "13px",
    background: "#347ff5",
    color: "#fff",
    border: 0,
    borderRadius: "9px",
    fontWeight: 800,
    cursor: "pointer",
  },
  message: {
    marginTop: "12px",
    fontSize: "13px",
    lineHeight: 1.5,
    overflowWrap: "anywhere",
  },
};
